import styled from 'styled-components'

export const IframeContainer = styled.div<{
  $height?: string
  $width?: string
}>`
  width: 100%;
  height: ${(props) => props.$height || 'auto'};
  display: flex;
  flex-direction: column;

  iframe {
    width: ${(props) => props.$width || '100%'};
    height: 100%;
    border: none;
    border-radius: 4px;
    display: block;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 600px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
`

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 600px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 4px;
  font-size: 14px;
  color: #c33;
  padding: 16px;
  text-align: center;
`
